'use client'

import HowItWorksOverlay from '@/components/HowItWorksOverlay/HowItWorksOverlay.tsx'
import { ConsentType } from '@/helpers/consent'

export default function BorrowDialogContentClient() {
  return (
    <HowItWorksOverlay
      type={ConsentType.Borrow}
      title="How Borrowing Works"
      steps={[
        {
          title: 'Provide Collateral',
          description:
            "Deposit the asset you want to borrow against. Keep in mind that you can only borrow from the market where you've supplied collateral. If you intend to borrow from multiple markets, you'll need to supply collateral to each market."
        },
        {
          title: 'Borrow Liquidity',
          description:
            "Borrow liquidity up to an amount based on the value of provided collateral and available liquidity. Borrowers are charged an interest rate on the borrowed amount, determined by the market's interest rate model."
        },
        {
          title: 'Monitor Position',
          description:
            'Monitor the LTV of your positions to avoid being eligible for liquidation. If the loan-to-value-ratio of a position exceeds the liquidation loan-to-value-ratio of a given market, external liquidators can liquidate your collateral to repay your outstanding debt.'
        },
        {
          title: 'Repay Debt',
          description:
            'Repay your outstanding loans by returning the initial borrowed amount plus the accrued interest.'
        }
      ]}
      terms={
        <>
          {
            'Morpho is committed to industry-leading security practices, but there are still risks associated with '
          }
          <a
            href="https://docs.morpho.org/morpho/concepts/risk-documentation"
            target="_blank"
            rel="noreferrer"
          >
            Morpho
          </a>
          {' including liquidation risk.'}
        </>
      }
    />
  )
}
